export const GET_DOCTOR = "GET_DOCTOR";
export const PRODUCT_REQUEST = "PRODUCT_REQUEST";
export const PRODUCT_GET_SUCCESS = "PRODUCT_GET_SUCCESS";
export const PRODUCT_FAILURE = "PRODUCT_FAILURE"
export const view = "view"